import React, { useState } from "react";
import { Button, Form, Input, message, Modal, Spin, Radio, Select } from "antd";
import { updateDispatch } from "../../Services/Services";
import Header from "../Header-Footer/Header";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Header-Footer/Footer";
import TextArea from "antd/es/input/TextArea";
const OrderNewEntry = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const receivedData = location.state?.data || {};
  form.setFieldsValue({
    client_name: receivedData.client_name,
    do_no: receivedData.do_no,
    pan_no: receivedData.pan_no,
    vehicle_no: receivedData.vehicle_no,
    truck_owner_name: receivedData.truck_owner_name,
    dispatch_quantity: receivedData.dispatch_quantity,
    freight_rate: receivedData.freight_rate,
    advance: receivedData.advance,
    shortage_rate: receivedData.shortage_rate,
    moisture_per: receivedData.moisture_per,
  });
  const handleValuesChange = (changedValues, allValues) => {
    const actual_quantity = parseFloat(
      (
        ((100 -
          parseFloat(
            allValues.moisture_received_per === undefined
              ? 0
              : allValues.moisture_received_per
          )) *
          parseFloat(
            allValues.dispatch_quantity === undefined
              ? 0
              : allValues.dispatch_quantity
          )) /
        (100 - parseInt(allValues.moisture_per))
      ).toFixed(3)
    );
    const freight_quantity = Math.min(
      parseFloat(
        allValues.dispatch_quantity === undefined
          ? 0
          : allValues.dispatch_quantity
      ),
      parseFloat(
        allValues.received_quantity === undefined
          ? 0
          : allValues.received_quantity
      )
    );
    const sort_quantity =
      parseFloat(
        allValues.dispatch_quantity === undefined
          ? 0
          : allValues.dispatch_quantity
      ) -
        parseFloat(freight_quantity) >
      (allValues.shortage_less === undefined
        ? 0.05
        : parseFloat(allValues.shortage_less))
        ? (
            parseFloat(
              allValues.dispatch_quantity === undefined
                ? 0
                : allValues.dispatch_quantity
            ) - parseFloat(freight_quantity)
          ).toFixed(3)
        : 0;
    const sort_amount = (
      parseFloat(sort_quantity) * parseFloat(allValues.shortage_rate)
    ).toFixed(3);
    const moisture_deduct_quantity = (
      allValues.dispatch_quantity === undefined
        ? 0
        : allValues.dispatch_quantity - actual_quantity
    ).toFixed(3);
    const moisture_deduct = Math.round(
      moisture_deduct_quantity *
        parseFloat(
          allValues.moisture_amount === undefined
            ? 0
            : allValues.moisture_amount
        )
    );
    const freight_amount = (
      parseFloat(
        allValues.freight_rate === undefined ? 0 : allValues.freight_rate
      ) *
        parseFloat(freight_quantity) -
      parseFloat(moisture_deduct) -
      parseFloat(sort_amount)
    ).toFixed(3);
    const tds = (
      (parseFloat(allValues.tds_per === undefined ? 0 : allValues.tds_per) *
        parseFloat(freight_amount)) /
      100
    ).toFixed(3);
    const total_amt = (
      parseFloat(freight_amount) -
      parseFloat(tds) -
      parseFloat(allValues.advance === undefined ? 0 : allValues.advance)
    ).toFixed(3);
    const pay_amount = (
      parseFloat(total_amt) -
      parseFloat(allValues.commision === undefined ? 0 : allValues.commision)
    ).toFixed(3);
    form.setFieldsValue({
      actual_quantity,
      freight_quantity,
      sort_quantity,
      moisture_deduct_quantity,
      moisture_deduct,
      sort_amount,
      freight_amount,
      tds,
      total_amt,
      pay_amount,
    });
  };

  const onFinish = async (values) => {
    Object.assign(values, { order_id: receivedData.id });
    setLoading(true);
    const response = await updateDispatch(receivedData.id, values);
    setLoading(false);
    if (response.msg === "Order updated successfully") {
      message.success("Freight Creation Successfully");
      navigate("/lifter-dispatch-view");
      form.resetFields();
    } else {
      message.warning("Freight Creation Not successfully");
    }
  };

  return (
    <>
      <Header heading="ORDER ENTRY" />
      <Modal open={loading} footer={null} closable={false} width={400}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src="transduniyalogo.png"
            alt="img"
            width={200}
            style={{ margin: "10px" }}
          />

          <Spin />
          <h2>Order Creating......</h2>
        </div>
      </Modal>
      <div style={{ width: "100%", overflowY: "auto", maxHeight: "85vh" }}>
        <Form
          style={{
            margin: "auto",
            width: "100%",
            maxWidth: "1200px",
            padding: "10px",
          }}
          form={form}
          onFinish={onFinish}
          layout="vertical"
          onValuesChange={handleValuesChange}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            <Form.Item
              name="client_name"
              rules={[
                {
                  required: true,
                  message: "Please select Party Name!",
                },
              ]}
              label={<b>Party Name</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input disabled style={{ fontWeight: "600", color: "black" }} />
            </Form.Item>

            <Form.Item
              name="do_no"
              rules={[
                {
                  required: true,
                  message: "Please select the DO ID!",
                },
              ]}
              label={<b>DO No</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input disabled style={{ fontWeight: "600", color: "black" }} />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Transporter Name!",
                },
              ]}
              name="truck_owner_name"
              label={<b>Truck Owner Name </b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Transporter Name"
                size="middle"
                disabled={
                  receivedData.truck_owner_name === "" ||
                  receivedData.truck_owner_name === null ||
                  receivedData.truck_owner_name === undefined
                    ? false
                    : true
                }
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              name="pan_no"
              rules={[
                {
                  required: true,
                  message: "Please Enter Pan No!",
                },
              ]}
              label={<b>PAN No</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="PAN No"
                size="middle"
                minLength={10}
                maxLength={10}
                disabled={
                  receivedData.pan_no === "" ||
                  receivedData.pan_no === null ||
                  receivedData.pan_no === undefined
                    ? false
                    : true
                }
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              name="vehicle_no"
              rules={[
                {
                  required: true,
                  message: "Please Enter Vehicle No!",
                },
              ]}
              label={<b>Vehicle No</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Vehicle No"
                size="middle"
                maxLength={10}
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              name="shortage_less"
              // rules={[
              //     {
              //         required: true,
              //         message: "Please Select Less Qty!",
              //     },
              // ]}
              label={<b>Shortage Less Qty</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                defaultValue={0.05}
              >
                <Select.Option value={0.05}>50kg</Select.Option>
                <Select.Option value={0.06}>60kg</Select.Option>
                <Select.Option value={0.07}>70kg</Select.Option>
                <Select.Option value={0.08}>80kg</Select.Option>
                <Select.Option value={0.09}>90kg</Select.Option>
                <Select.Option value={0.1}>100kg</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Dispatch Quantity!",
                },
              ]}
              name="dispatch_quantity"
              label={<b>Dispatch Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Dispatch Quantity"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Recieved Quantity!",
                },
              ]}
              name="received_quantity"
              label={<b>Received Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Received Quantity"
                type="number"
                size="middle"
                //  onKeyPress={handlePhoneKeyPress}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Freight Quantity!",
                },
              ]}
              name="freight_quantity"
              label={<b>Freight Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                defaultValue={0}
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Sort Quantity!",
                },
              ]}
              name="sort_quantity"
              label={<b>Sort Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Shortage Rate!",
                },
              ]}
              name="shortage_rate"
              label={<b>Shortage Rate</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Amount!",
                },
              ]}
              name="sort_amount"
              label={<b>Sort Amount</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Moisture %!",
                },
              ]}
              name="moisture_per"
              label={<b>Moisture % (Less)</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Enter Moisture %"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Moisture %!",
                },
              ]}
              name="moisture_received_per"
              label={<b>Moisture % (Received)</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Enter Moisture Received %"
                type="number"
                size="middle"
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Actual Quantity!",
                },
              ]}
              name="actual_quantity"
              label={<b>Actual Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Moisture Deduct Quantity!",
                },
              ]}
              name="moisture_deduct_quantity"
              label={<b>Moisture Deduct Quantity</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Amount!",
                },
              ]}
              name="moisture_amount"
              label={<b>Moisture Amount</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Amount" type="number" size="middle" />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Moisture Deduct!",
                },
              ]}
              name="moisture_deduct"
              label={<b>Moisture Deduct</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Freight Rate!",
                },
              ]}
              name="freight_rate"
              label={<b>Freight Rate</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Freight Rate"
                type="number"
                size="middle"
                disabled={
                  localStorage.getItem("user_type") === "Admin" ? false : true
                }
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Freight Amount!",
                },
              ]}
              name="freight_amount"
              label={<b>Freight Amount</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Tds %!",
                },
              ]}
              name="tds_per"
              label={<b>TDS %</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Enter TDS %" type="number" size="middle" />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Tds Amount!",
                },
              ]}
              style={{ padding: "2px", margin: "2px" }}
              name="tds"
              label={<b>TDS</b>}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Advance Amount!",
                },
              ]}
              name="advance"
              label={<b>Advance</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="Advance"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Pay Amount!",
                },
              ]}
              name="total_amt"
              label={<b>Total Amount</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Commission!",
                },
              ]}
              name="commision"
              label={<b>Commission</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input placeholder="Commission" type="number" size="middle" />
            </Form.Item>

            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Please Enter Pay Amount!",
                },
              ]}
              name="pay_amount"
              label={<b>Pay Amount</b>}
              style={{ padding: "2px", margin: "2px" }}
            >
              <Input
                placeholder="0"
                type="number"
                size="middle"
                disabled
                style={{ fontWeight: "600", color: "black" }}
              />
            </Form.Item>
            <Form.Item
              name="is_applicable"
              label={<b>Freight Payment Issues</b>}
              style={{ padding: "2px", margin: "2px" }}
              rules={[
                {
                  required: true,
                  message: "Please Select!",
                },
              ]}
            >
              <Radio.Group>
                <Radio value={false}>No</Radio>
                <Radio value={true}>Yes</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="description"
              label={<b>Description</b>}
              style={{ gridColumn: "span 3", width: "100%" }}
            >
              <TextArea
                placeholder="Enter Description"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </div>
          <Form.Item
            style={{
              textAlign: "center",
              marginTop: "10px",
              width: "100%",
            }}
          >
            <Button
              htmlType="submit"
              style={{
                backgroundColor: "black",
                color: "white",
                width: "200px",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Footer />
    </>
  );
};

export default OrderNewEntry;
